import { Icon } from "@iconify/react";
import "./style.scss"
import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate= useNavigate();
  return (
    <section>
      <div className="d-flex justify-content-between">
        <h2 className="title">Services</h2>
      </div>
      <div className="row gap-3">
        <div className="card bg-hover-light shadow col-md-3 col-sm-12 p-3 cursor-pointer" onClick={()=>navigate("/services/notification")}>
           <div className="d-flex gap-3">
             <span>
                 <Icon height={34} width={34} icon={"material-symbols:notifications-active"} />
             </span>
             <div>
             <span>
                Notification
             </span>
             <p className="fs-7 mt-2">
                Send Notification
             </p>
             </div>
           </div>
        </div>
        <div className="card bg-hover-light shadow col-md-3 col-sm-12 p-3 cursor-pointer" onClick={()=>navigate("/services/track")}>
           <div className="d-flex gap-3">
             <span>
                 <Icon height={34} width={34} icon={"material-symbols:my-location-outline-rounded"} />
             </span>
             <div>
             <span>
                Track Employee
             </span>
             <p className="fs-7 mt-2">
                Tracking location
             </p>
             </div>
           </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
